import styled from 'styled-components';

// Paleta de busca global (Ctrl+K) — tokens CCO, fundo solido (sem
// backdrop-filter: nao renderiza bem em navegador de TV).

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 70;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 14vh 16px 16px;
`;

export const Panel = styled.div`
  width: 100%;
  max-width: 580px;
  max-height: 64vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--cco-surface);
  border: 1px solid var(--cco-line);
  border-radius: 14px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--cco-line);
  color: var(--cco-ink-faint);

  > svg {
    flex-shrink: 0;
  }

  > input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: var(--cco-ink);
    font-size: 15px;
    font-weight: 500;
    font-family: inherit;

    &::placeholder {
      color: var(--cco-ink-faint);
    }
  }
`;

export const EscHint = styled.span`
  flex-shrink: 0;
  padding: 2px 7px;
  border-radius: 6px;
  border: 1px solid var(--cco-line);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cco-ink-faint);
`;

export const Results = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 6px 0 8px;

  scrollbar-width: thin;
  scrollbar-color: var(--cco-line-strong) transparent;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--cco-line-strong);
    border-radius: 3px;
  }
`;

export const Empty = styled.div`
  padding: 26px 16px;
  text-align: center;
  color: var(--cco-ink-faint);
  font-size: 13px;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GroupLabel = styled.div`
  padding: 10px 16px 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--cco-ink-faint);
`;

export const Item = styled.button`
  display: flex;
  align-items: baseline;
  gap: 10px;
  width: 100%;
  padding: 9px 16px;
  background: ${(props) =>
    props.$active ? 'var(--cco-soft-surface)' : 'transparent'};
  border: none;
  border-left: 2px solid
    ${(props) => (props.$active ? 'var(--cco-blue)' : 'transparent')};
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  min-width: 0;

  .lbl {
    font-size: 14px;
    font-weight: 700;
    color: var(--cco-ink);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
    max-width: 55%;
  }
  .sub {
    font-size: 12px;
    font-weight: 500;
    color: var(--cco-ink-faint);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }
`;

export const Foot = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 16px;
  border-top: 1px solid var(--cco-line);
  font-size: 10.5px;
  font-weight: 600;
  color: var(--cco-ink-faint);
`;
